namespace app.autenticacao {
    "use strict";
    import InformacaoService = app.toolbar.InformacaoService;

    interface InformacaoScope extends ng.IScope {
        value: string;
        tipo: string;
        params: string;
    }

    class InformacaoDirective implements ng.IDirective {

        public restrict: string = "E";

        public scope: Object = {
            value: "=",
            tipo: "=",
            params: "@"
        };

        constructor(private $timeout: ng.ITimeoutService, private informacaoService: InformacaoService, private $compile: ng.ICompileService) {	}

        public link: ng.IDirectiveLinkFn = (scope: InformacaoScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes): void => {
            scope.$watchGroup([() => { return scope.value; }, () => { return scope.tipo; }, () => { return scope.params; }], (newValue, oldValue) => {
                let consulta: any = this.informacaoService.getViewer();
                let processo = newValue;
                let controller = consulta.controller;
                let params = processo.pop().replace(/"/g, "'");
                let template = consulta.template;
                let alias = consulta.controllerAs;
                if (!params) {
                    params = `''`;
                }
                let directiveHtml = `<div data-ng-controller="${controller} as ${alias}" ng-init="${alias}.init('${processo}', ${params})">${template}</div>`;
                element.html(directiveHtml);

                let link = this.$compile(element.contents());
                
                link(scope);
            });
        }

        public static factory(): ng.IDirectiveFactory {
            return ($timeout: ng.ITimeoutService, informacaoService: InformacaoService, $compile: ng.ICompileService) => {
                "ngInject";
                return new InformacaoDirective($timeout, informacaoService, $compile);
            };
        }

    }

    angular.module("app.autenticacao").directive("informacao", InformacaoDirective.factory());
}